/* ==========================================================================
   LUMËE — sélecteur d'offres : relie les cartes au <product-form> existant.

   Le formulaire de Dawn sait déjà poster vers /cart/add.js et rendre le tiroir.
   Ce fichier ne fait donc QUE trois choses quand la sélection change :
     1. écrire l'id de variante dans l'input caché du formulaire
     2. écrire la quantité
     3. mettre le prix de l'offre dans le libellé du bouton

   Aucun appel réseau ici. Dupliquer l'ajout au panier aurait créé un second
   chemin à maintenir, et deux comportements qui divergent au premier correctif.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    if (!cards.length) return;

    // Le formulaire n'est pas forcément un frère du sélecteur selon la mise en
    // page : on remonte au conteneur de la fiche avant de chercher.
    var scope = root.closest('.facil-pdp__info') || root.closest('facil-pdp') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var idInput = form.querySelector('.product-variant-id, input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }
    var btnPrice = scope.querySelector('[data-pdp-btn-price]');

    function money(cents) {
      // On réutilise le format de la boutique quand il est exposé, pour ne pas
      // réinventer séparateurs et position du symbole selon la devise.
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.themeMoneyFormat) {
        return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function select(card) {
      if (card.classList.contains('is-out')) return;

      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-on', on);
        var r = c.querySelector('.facil-offer__radio');
        if (r) r.checked = on;
      });

      var id = card.getAttribute('data-variant-id');
      var qty = card.getAttribute('data-quantity') || '1';
      var price = parseInt(card.getAttribute('data-price'), 10);

      if (idInput && id) {
        idInput.value = id;
        idInput.removeAttribute('disabled');
      }
      qtyInput.value = qty;

      if (btnPrice && !isNaN(price)) btnPrice.textContent = money(price);

      root.dispatchEvent(
        new CustomEvent('offer:change', {
          bubbles: true,
          detail: { variantId: id, quantity: parseInt(qty, 10), price: price }
        })
      );
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Le <label> coche déjà le radio ; sans ça le clic serait compté deux fois.
        if (e.target.classList.contains('facil-offer__radio')) return;
        e.preventDefault();
        select(card);
      });
      var radio = card.querySelector('.facil-offer__radio');
      if (radio) radio.addEventListener('change', function () { if (radio.checked) select(card); });
    });

    // État de départ : la carte marquée par le thème, sinon la première libre.
    var start = cards.filter(function (c) { return c.classList.contains('is-on') && !c.classList.contains('is-out'); })[0]
             || cards.filter(function (c) { return !c.classList.contains('is-out'); })[0];
    if (start) select(start);
  }

  function boot() {
    document.querySelectorAll('[data-offers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // L'éditeur de thème re-rend la section sans recharger la page : sans ça, le
  // sélecteur cesse de répondre dès qu'on modifie un réglage.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-offers]').forEach(init);
  });
})();
